import {buttonColors} from "../../Pickers/InputTheme";
import {isSignDocComplete} from "../SignDocLib";


export const getCardDesignValues = ({progressPercent, viewed, signed, finishByDate, type, i18n, isRejected = false}) => {
    let buttonColor, message, completionClass, buttonText;

    const isComplete = isSignDocComplete({type, progressPercent, viewed, signed});

    // Handle rejected state
    if(isRejected){
        buttonColor = buttonColors.GOLD
        message = i18n.translate('signDocCard.rejectedMessage')
        buttonText = i18n.translate('signDocCard.uploadAgain')
        completionClass = 'rejected'
    }
    else if(isComplete){
        buttonColor = buttonColors.GOLD
        message = i18n.translate(`signDocCard.youAreDone.${type}`)
        buttonText = i18n.translate(`signDocCard.youAreDoneWatchAgain.${type}`)
        completionClass = 'completed'
    }
    else if(viewed && (!signed || (progressPercent > 0 && progressPercent < 100))) {
        buttonColor = buttonColors.GOLD
        message = finishByDate
            ? i18n.translate(`signDocCard.finishBy.${type}`, {context: {finishByDate}})
            : i18n.translate('signDocCard.noDateSet')
        buttonText = i18n.translate(`signDocCard.goToCourse.${type}`)
        completionClass = 'inProgress'
    }
    else {
        buttonColor = buttonColors.GOLD
        message = finishByDate
            ? i18n.translate(`signDocCard.finishBy.${type}`, {context: {finishByDate}})
            : i18n.translate('signDocCard.noDateSet')
        buttonText = i18n.translate(`signDocCard.goToCourse.${type}`)
        completionClass = 'notStarted'
    }
    return {buttonColor, message, completionClass, buttonText}
}
